import React from 'react';
import ComponentLog from '@/components/component-log';

export default function TimeSelector(props) {
  const { status, setStatus } = props;

  const descIcon =
    'https://img13.360buyimg.com/imagetools/jfs/t1/136575/37/17161/492/5fbf6e69Eb0715f8f/e9a7e46ec91db7e6.png';
  const ascIcon =
    'https://img12.360buyimg.com/imagetools/jfs/t1/160774/29/3925/648/600a6ed4Eb4d2c760/3b48bc4f7fdd5366.png';
  const defaultIcon =
    'https://img12.360buyimg.com/imagetools/jfs/t1/160940/31/3949/614/600a6ed4E154e4905/585a2cd2469c365f.png';

  const selector = (asc, desc) => () => {
    if (status !== asc) {
      setStatus(asc);
    } else {
      setStatus(desc);
    }
  };

  const iconSelector = (asc, desc) => {
    if (status === asc) {
      return ascIcon;
    } else if (status === desc) {
      return descIcon;
    } else {
      return defaultIcon;
    }
  };

  const TimeSelectorItem = (props) => {
    const { asc, desc, title, style, cls } = props;
    return (
      <div className="report-process-header-wrapper-item" style={style}>
        <div>{title}</div>
        <ComponentLog>
          <div clstag={cls} className="report-process-header-img" onClick={selector(asc, desc)}>
            <img src={iconSelector(asc, desc)} width={12} height={12} />
          </div>
        </ComponentLog>
      </div>
    );
  };

  return (
    <div className="report-process-time-selector-wrapper">
      <TimeSelectorItem asc={0} desc={1} title="活动开始时间" cls="hd_gallery_1611304306662|1" />
      <TimeSelectorItem
        asc={2}
        desc={3}
        style={{ paddingLeft: 10 }}
        title="活动结束时间"
        cls="hd_gallery_1606447516680|16"
      />
    </div>
  );
}
